import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "components/Breadcrumbs";
import Footer from "components/Footer";
import MDBox from "components/MDBox";
import MDCircularProgress from "components/MDCircularProgress";
import MDForbidden from "components/MDForbidden";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setLayout, useMaterialUIController } from "context";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import authPermission from "utility/auth-permissions";

function DashboardLayout({ children, light, isMini, breadcrumbsTitle, isNotFound, isData }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();
  
  // Loading state for permission check
  const [loadingPermission, setLoadingPermission] = useState(true);
  const [isPermission, setIsPermission] = useState(null); // Start with null to detect permission check

  const { hasPermission, getHandlerPath } = authPermission();
  const { action } = useParams();

  let permissionKey;
  let permission = null;

  switch (action) {
    case "add":
      permissionKey = "new";
      break;
    case "edit":
      permissionKey = "edit";
      break;
    default:
      permissionKey = "view";
  }

  const handler = getHandlerPath(pathname, [action]);
  permission = hasPermission(handler);

  const route = useLocation().pathname.split("/").slice(1);

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  useEffect(() => {
    // Wait for permission check to complete
    if (permission !== null && handler) {
      // setIsPermission(permission[permissionKey]);
      if (permissionKey === 'edit') {
          setIsPermission(permission['view']);
      } else {
          setIsPermission(permission[permissionKey]);
      }
      setTimeout(() => {
        setLoadingPermission(false); // Stop loading once permissions are determined
      }, 5);
    }
  }, [permission, handler]);

  return (
    <>
      <DashboardNavbar />
      <MDBox
        sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
          pt: 0,
          pr: 2,
          pb: 3,
          pl: 3,
          position: "relative",
          zIndex: 1100,
          [breakpoints.up("xl")]: {
            marginLeft: miniSidenav ? pxToRem(64) : pxToRem(242),
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
        })}
      >
        {loadingPermission || isPermission === null || !isData ? (
          // Show loading spinner while permissions are being checked
          <MDBox sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <MDCircularProgress size={150} />
          </MDBox>
        ) : isPermission === 1 && !isNotFound ? (
          <>
            <Grid mt={2} container>
              <Grid item xs={8}>
                <MDTypography
                  variant="h5"
                  sx={{ fontWeight: "bold", color: "rgba(255, 255, 255, .85)" }}
                >
                  {breadcrumbsTitle}
                </MDTypography>
              </Grid>
              <Grid item xs={4}>
                <Breadcrumbs icon="home" title={breadcrumbsTitle || ""} route={route} light={light} />
              </Grid>
            </Grid>
            <MDBox mt={3} pb={3}>
              <Grid container spacing={6}>
                <Grid item xs={12} sx={{ marginTop: "1rem", paddingTop: "2rem !important" }}>
                  <Card sx={{ borderRadius: "3px 3px 5px 5px", padding: "15px", minHeight: "350px" }}>
                    {children}
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          </>
        ) : (
          <MDBox mt={3} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12} sx={{ marginTop: "1rem", paddingTop: "2rem !important" }}>
                <Card sx={{ borderRadius: "3px 3px 5px 5px", padding: "15px", minHeight: "350px" }}>
                  <MDForbidden  isNotFound={isNotFound} />
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        )}
        <Footer />
      </MDBox>
    </>
  );
}

// Setting default values for the props of DashboardLayout
DashboardLayout.defaultProps = {
  isNotFound: false,
  isData: true,
};

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
